import Constants from '../utils/consts';
import Utils from '../utils/utils';

var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function manageCompany(uname, token, id, eventId, brokerId, 
                                            name, logo_simple, logo, market_cap, sector, pdf_profile, 
                                            web_site, rapresentative, contact_person, phone_number,
                                            mobile_number, email_address, second_email_address, more_emails, bloombergNumber, country, deleteFlag) {

    console.log(name, sector, rapresentative, contact_person, country)
    if (name) name = Utils.escapeString(name);
    if (sector) sector = Utils.escapeString(sector);
    if (rapresentative) rapresentative = Utils.escapeString(rapresentative);
    if (contact_person) contact_person = Utils.escapeString(contact_person);
    if (country) country = Utils.escapeString(country);


    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/manageCompany.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        console.log(more_emails);

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            let asd = body.toString();
            resolve(JSON.parse(body.toString()));
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'id' : id,
        'eventId' : eventId,
        'brokerId' : brokerId,
        'name' : name,
        'logo_simple' : logo_simple,
        'logo' : logo,
        'market_cap' : market_cap,
        'sector' : sector,
        'pdf_profile' : pdf_profile,
        'web_site' : web_site,
        'rapresentative' : rapresentative,
        'contact_person' : contact_person,
        'phone_number' : phone_number,
        'mobile_number' : mobile_number,
        'email_address' : email_address,
        'second_email_address' : second_email_address,
        'more_emails': more_emails,
        'bloombergNumber' : bloombergNumber,
        'country' : country,
        'deleteFlag' : deleteFlag,
    });

        req.write(postData);

        req.end();

        
    });
}
